import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const floatingButtonWrapper = css`
  position: fixed;
  inset-block-end: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  block-size: unset;
  box-shadow: ${cssTheme.shadows.topNormal};
  padding-block-end: ${spacing(6)};
`
